import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ColumnOrder } from '@core/table/order';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import * as FileSaver from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '@core/services/dialog.service';
import { MessageService } from '@core/services/message.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { RoleEnum } from '@core/models/role';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { ModalOptions, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AppSignalDataService } from 'src/app/app-signal-data.service';

import { BehaviorSubject, Observable, of } from 'rxjs';
import { RouteAction } from '@core/action/action';

@Component({
  selector: 'app-historico-list',
  templateUrl: './historico-list.component.html',
  styleUrls: ['./historico-list.component.scss']
})
export class HistoricoListComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() entidade: any;
  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  @Output() dadosHistoricoEmit = new EventEmitter<any>();

  historicoFilterForm!: FormGroup;
  roleEnum = RoleEnum;
  columOrder: ColumnOrder | undefined;

  statusHistorico: any[] = [];
  empresas: any[] = [];
  statusHistoricos: any[] = [];

  validaDetrans: any;
  size: NzButtonSize = 'large';
  situacoes: any[] = [];
  tiposHistorico: any[] = [];
  historicosSuperior: any;
  searchChange$ = new BehaviorSubject('');
  optionList: string[] = [];
  gruposEconomico: any[] = [];
  nzpage = 0;
  total = 0;
  nzFilterOption = (): boolean => true;

  loading = false;

  constructor(
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    private router: Router,

    private modalService: NzModalService,
    private appSignalDataService: AppSignalDataService,
  ) {
    this.appSignalDataService.updateCollapsedMenuAside(true);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.entidade && this.entidade.entidadeHistoricos){
      const historicos = this.entidade.entidadeHistoricos;
      this.dataSet = historicos;
    }
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void { }

  onSearch(value: string): void {
    this.loading = true;
    this.searchChange$.next(value);
  }

  sort(event: any) {
    const column = event.sort.find((x: any) => x.value);
    if (column) {
      const sortKey = column.key;
      const sortOrder = column.value === 'ascend' ? 1 : -1;

      this.dataSet = [...this.dataSet].sort((a, b) => {
        const valueA = this.getNestedValue(a, sortKey);
        const valueB = this.getNestedValue(b, sortKey);

        if (valueA < valueB) {
          return -1 * sortOrder;
        }
        if (valueA > valueB) {
          return 1 * sortOrder;
        }
        return 0;
      });
    } else {
      this.dataSet = [...this.dataSet];
    }
  }

  getNestedValue(obj: any, key: string): any {
    return key.split('.').reduce((o, k) => (o ? o[k] : null), obj);
  }

}
